import { request } from '@/util/http'

export const getList = (wxUserId) => {
  return request({
    url: '/health/userCR/getList',
    method: 'get',
    params: {
      wxUserId
    }
  })
}

export const getDetail = (current, size, params) => {
  return request({
    url: '/health/userCR/detail',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/health/userCR/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/health/userCR/submit',
    method: 'post',
    data: row
  })
}

